import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import DateTimeRangePicker from '../../../Misc/DateTimeRangePicker'
import { MealTypesReports, MenuOrderTypes, currency_symbol, date_format } from '../../../../server/constants';
import TmExportExcel from '../../../Misc/tmExportExcel/tmExportExcel';
import { get } from '../../../../server/actions';
import {
    _addNotificationError, groupBy, isRegularLunchOrderType, showFile, getSchoolGrades, convertTwoDecimalPoint, getWeekStartEndDates, getMonthStartEndDates,
    getTodayStartEndDates, getSessionStartEndDates, getLastMonthStartEndDates
} from '../../../../server/util'
import DateRangePicker from 'react-bootstrap-daterangepicker';
var _ = require('lodash');
class AdjustmentReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            adjustments: [],
            selectedDates: {
                startDate: moment(moment((this.props.activeMonth || moment()), 'YYYYMM')).startOf('month'),
                endDate: moment(moment((this.props.activeMonth || moment()), 'YYYYMM')).endOf('month')
            },
        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.setState({ mealType: '' }, () => {
            this.getBalanceAdjustments(this.state.selectedDates.startDate, this.state.selectedDates.endDate, false);
        });
    }

    onChangeDateRange = (startDate, endDate) => {
        let _selectedDate = { startDate: startDate, endDate: endDate }
        this.setState({ selectedDates: _selectedDate },
            this.getBalanceAdjustments(startDate, endDate, false)
        );
    }

    getBalanceAdjustments = (startDate, endDate, isPdf) => {
        let _self = this;
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));;
        let dateStart = moment(startDate).startOf('D');
        let dateEnd = moment(endDate).endOf('D');
        this.setState({ loading: true });
        get('/reports/transactionsReport?mealSchoolId=' + userInfo.schoolId + '&startDate='
            + moment(dateStart).utc().format("YYYY-MM-DDTHH:mm:ss") +
            '&endDate=' + moment(dateEnd).utc().format("YYYY-MM-DDTHH:mm:ss") +
            '&isDeposit=true&isAdjTrx=true&schoolYear=' + sessionStorage.getItem('schoolYearValue') +
            '&fileExport=' + isPdf + '&access_token='
        ).then(res => {
            if (res.statusCode === 417) {
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = 'adjustment_Report.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                this.setState({
                    adjustments: data.transactionReportsDetails, loading: false
                })
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self);
                this.setState({ loading: false })
            }
        );
    }

    buildAdjustmentReportFormatForExport = () => {
        let fData = [];
        let result = [];
        this.state.adjustments.map(row => {
            fData.push([
                row.studentId,
                row.studentFName,
                row.studentLName,
                row.pin,
                row.transactionDate,
                row.transactionTime,
                row.type,
                `${currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}`,
                row.transactionDesc,
                row.user
            ]);
        });
        result.push(
            {
                columns: ['', ''],
                data: [['Title:', 'Adjustment Transactions'], ['', '']]
            }
        )
        result.push(
            {
                columns: ["Student Id", "Student First Name", "Student Last Name", "Pin", "Transaction Date", "Transaction Time", "Type", `Amount (${currency_symbol()})`, "Description", "User"],
                data: fData
            }
        );
        return result;

    }
    render() {
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="panel panel-p1 panel-primary">

                    <div className="panel-heading text-center">
                        <h3 className="panel-title" style={{ display: 'inline' }}>Adjustment Transactions</h3>
                        <div style={{
                            display: 'inline-block',
                            backgroundColor: 'transparent',
                            marginTop: '-7px',
                            float: 'right',
                            borderRadius: '3px'
                        }}>
                            <div className="btn-group">
                                <button className="btn-link btn-sm dropdown-toggle" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                    <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                            onClick={() => { this.getBalanceAdjustments(this.state.selectedDates.startDate, this.state.selectedDates.endDate, true); }}
                                            target='_blank'
                                        ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                    </li>
                                    <li>
                                        <TmExportExcel id="adjustmentReport"
                                            name={"Adjustment Transactions Report"}
                                            filename={"Adjustment Transactions Report"}
                                            element={<a title="Click to Download Excel" id="adjustmentReport"
                                                style={{
                                                    display: 'block',
                                                    padding: '3px 20px',
                                                    clear: 'both',
                                                    fontWeight: '400',
                                                    lineHeight: 1.42857143,
                                                    color: '#333',
                                                    whiteSpace: 'nowrap',
                                                    cursor: 'pointer'
                                                }}
                                            ><i className="fa fa-file-excel-o" /> Excel</a>}
                                            dataSet={this.buildAdjustmentReportFormatForExport()}
                                        />
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="panel-body">
                        <div className='row' style={{ marginTop: '5px', marginBottom: '5px', fontSize: '16px' }}>
                            <div className='col-md-2'>
                                <label>Select date range:</label>
                            </div>
                            <div className='col-md-4'>
                                <DateTimeRangePicker
                                    startDate={this.state.selectedDates.startDate}
                                    endDate={this.state.selectedDates.endDate}
                                    isReport={false}
                                    applyCallback={(event, picker) => {
                                        this.onChangeDateRange(picker.startDate, picker.endDate)
                                    }}

                                    isDateShow={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                {/* {this.deposistsSummery(this.state.transactionData)} */}
                                <ul id={'adjustSummery'} className='pull-right' style={{ WebkitColumnCount: 3, MozColumnCount: 3, columnCount: 3, textAlign: 'center' }}>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <ReactTable ref={(r) => this.adjustTable = r} id={'adjustTbl'}
                                    filterable
                                    columns={[
                                        {
                                            Header: "Student First Name",
                                            id: "StudentFName",
                                            style: { textAlign: 'center' },
                                            accessor: "studentFName",
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.studentFName || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            },
                                            Footer: (props) => {
                                                const { data } = props;
                                                const tempList = (data).map(d => d._original);
                                                return <div style={{ textAlign: "center" }}>Total:  {tempList.length}</div>
                                            }
                                        },
                                        {
                                            Header: "Student Last Name",
                                            id: "StudentLName",
                                            style: { textAlign: 'center' },
                                            accessor: 'studentLName',
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.studentLName || '').toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: "Pin",
                                            id: "Pin",
                                            style: { textAlign: 'center' },
                                            accessor: row => {
                                                return (
                                                    <span>
                                                        {row.pin}
                                                    </span>
                                                );
                                            },
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.pin).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: "Date",
                                            accessor: "transactionDate",
                                            width: 100,
                                            style: { textAlign: 'center' },
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row['transactionDate']).startsWith(filter.value.toLowerCase())
                                            },
                                        },
                                        {
                                            Header: "Time",
                                            accessor: "transactionTime",
                                            width: 100,
                                            style: { textAlign: 'center' },
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row['transactionTime']).startsWith(filter.value.toLowerCase())
                                            },
                                        },
                                        {
                                            Header: "Type",
                                            id: 'type',
                                            accessor: 'type',
                                            style: { textAlign: 'center' },
                                            accessor: row => {
                                                return (
                                                    <span>
                                                        {row.type}
                                                    </span>
                                                );
                                            }, width: 150,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row['type']).toLowerCase().startsWith(filter.value.toLowerCase())
                                            },
                                            Filter: ({ filter, onChange }) => {
                                                return (
                                                    <select className="form-control"
                                                        onChange={event => onChange(event.target.value)}
                                                        value={filter ? filter.value : 'all'}
                                                    >
                                                        <option value={''}>{''}</option>
                                                        {_.map(
                                                            _.uniq(
                                                                _.map(this.state.adjustments, function (obj) {
                                                                    return obj.type;
                                                                })
                                                            )).map(item =>
                                                                <option value={item}>{item}</option>
                                                            )
                                                        }
                                                    </select>
                                                )
                                            },
                                            Footer: (props) => {
                                                const { data } = props;
                                                const tempList = (data).map(d => d._original);
                                                const groupData = groupBy(tempList, 'type');
                                                const id = document.getElementById('adjustSummery');
                                                const lstString = Object.keys(groupData).map((item) => {
                                                    return `<li><label class="color-1">Total ${item} Count:</label> <strong class="color-4">${groupData[item].length}</strong></li>`
                                                })

                                                if (id) {

                                                    id.innerHTML = lstString.join('');
                                                }
                                                return <div style={{ textAlign: "center" }}></div>
                                            }
                                        },
                                        {
                                            Header: `Amount (${currency_symbol()})`,
                                            id: 'amount',
                                            width: 100,
                                            filterable: false,
                                            accessor: row => {
                                                return (
                                                    <div style={{ textAlign: "center" }}>
                                                        {currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}
                                                    </div>
                                                );
                                            },
                                            Footer: (props) => {
                                                const { data } = props;
                                                const tempList = (data).map(d => d._original);
                                                return <div style={{ textAlign: "center" }}> {currency_symbol() + ' ' + (_.sum(_.map(tempList, d => d.amount))).toFixed(2)}</div>
                                            }
                                        },
                                        {
                                            Header: "Desc",
                                            id: 'transactionDesc',
                                            style: { textAlign: 'center' },
                                            accessor: 'transactionDesc'
                                        },
                                        {
                                            Header: "User",
                                            accessor: "user",
                                            minWidth: 120,
                                            style: { textAlign: 'center' },
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        }

                                    ]}
                                    data={_.orderBy(this.state.adjustments, ['studentLName', 'studentFName'], ['asc'])}
                                    defaultPageSize={10} className="-striped -highlight" {...checkboxProps} />
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        );
    }
}

export default AdjustmentReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/adjustmentReport.jsx